import cloneDeep from 'clone-deep'

import {
	SAVE_TEXT,
	SAVE_URL_LIST,
	SAVE_SELECTED_URL_LIST,
	UPDATE_URL_LIST,
	UPDATE_ACCOUNT_LIST,
	DELETE_URL_LIST,
	DELETE_SELECTED_URL_LIST,
	DELETE_DUPLICATE_URL_LIST
} from '../actions/actionTypes'

import {updateObject} from '../../utils/utils'
import accountList from '../../config/accounts'

const initialState = {
	text: '',
	urlList: [],
	selectedUrlList: [],
	duplicateUrlList: [],
	accountList: cloneDeep(accountList)
}

export default function textReducer(state = initialState, action) {
	switch (action.type) {
		case SAVE_TEXT:
			return updateObject(state, {
				text: action.text
			})
		case SAVE_URL_LIST:
			return updateObject(state, filterDuplicateUrls(
				state.urlList,
				state.duplicateUrlList,
				action.urlList
			))
		case SAVE_SELECTED_URL_LIST:
			return updateObject(state, {
				selectedUrlList: action.urlList
			})
		case UPDATE_URL_LIST:
			return updateObject(state, {
				urlList: updateUrlList(state.urlList, action.urlList)
			})
		case UPDATE_ACCOUNT_LIST:
			return updateObject(state, {
				accountList: updateAccountList(state.accountList, action.accountUrl)
			})
		case DELETE_URL_LIST:
			return updateObject(state, {
				urlList: [],
				selectedUrlList: [],
				duplicateUrlList: []
			})
		case DELETE_SELECTED_URL_LIST:
			return updateObject(state, {
				selectedUrlList: []
			})
		case DELETE_DUPLICATE_URL_LIST:
			return updateObject(state, {
				duplicateUrlList: []
			})
		default:
			return state
	}
}

export function prepareUrlListForRender(urlList, isVisited = false) {
	return urlList.map(url => ({url, isVisited}))
}

function filterDuplicateUrls(existingUrlList, duplicateUrlList, newUrlList = []) {
	const newList = [...newUrlList]
	const existingList = existingUrlList.map(item => item.url)
	const duplicateList = duplicateUrlList.map(item => item.url)

	newList.forEach(url => {
		if (!existingList.includes(url)) {
			existingList.push(url)
		} else {
			duplicateList.push(url)
		}
	})

	return {
		urlList: prepareUrlListForRender(existingList),
		duplicateUrlList: prepareUrlListForRender(duplicateList)
	}
}

function updateAccountList(existingAccountList, newAccountUrl) {
	const accountList = cloneDeep(existingAccountList)

	accountList.forEach(account => {
		if (account.url === newAccountUrl) {
			account.isVisited = true
		}
	})

	return accountList
}

function updateUrlList(existingUrlList, newUrlList = []) {
	const urlList = cloneDeep(existingUrlList)

	urlList.forEach(item => {
		newUrlList.forEach(newItem => {
			if (item.url === newItem ) {
				item.isVisited = true
			}
		})
	})

	return urlList
}